const ScheduleRoutePage = () => {
    return (
      <div>
        <h1>Hola Mysuscripcion</h1>
      </div>
    );
  };
  
  export default ScheduleRoutePage;
  